<template>
  <div>
    <e-dialog
      dialog-title="订单操作日志"
      :center-dialog-visible="orderOperationLogVisible"
      :show-sub-btn="false"
      popup-width="800px"
      @resetPopupData="resetPopupData"
    >
      <tableList
        ref="tableRef"
        max-height="500"
        class="margin-t20"
        :loading="false"
        row-key="vocabularyId"
        :table-data="tableData"
        :table-label="tableLabel"
      >
        <template #showIndex="slotScope">
          <span>
            {{ (queryData.pageNum - 1) * queryData.pageSize + slotScope.scope.$index + 1 }}
          </span>
        </template>
      </tableList>
      <div class="pagination">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :page-size="queryData.pageSize"
          :total="pageTotal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </e-dialog>
  </div>
</template>

<script>
import eDialog from '@/modules/projectA/components/common/e-dialog';
import tableList from '@/modules/projectA/components/common/e-table-list';
import api from '@/modules/projectA/api/order';

export default {
  name: 'OrderDetailsDialog',
  components: {
    eDialog,
    tableList,
  },
  props: {
    orderOperationLogVisible: Boolean,
    logData: Object,
  },
  data() {
    return {
      queryData: {
        keyMessage: null,
        companyId: null,
        pageNum: 1,
        pageSize: 10,
      },
      pageTotal: 0,
      tableData: [],
      tableLabel: [
        {
          label: '序号',
          slot: 'showIndex',
          align: 'center',
          width: '80px',
        },
        {
          label: '订单操作',
          param: 'operateType',
          align: 'center',
        },
        {
          label: '操作人',
          param: 'memberRealName',
          align: 'center',
        },
        {
          label: '联系方式',
          param: 'memberMobile',
          align: 'center',
        },
        {
          label: '邮箱',
          param: 'memberEmail',
          align: 'center',
        },
        {
          label: '操作时间',
          param: 'logTime',
          align: 'center',
        },
      ],
    };
  },
  mounted() {
    this.queryData.keyMessage = this.logData.orderNo;
    this.queryData.companyId = this.logData.purchaseCompanyId;
    this.orderLogQueryPage();
  },
  methods: {
    handleSizeChange(val) {
      this.queryData.pageSize = val;
      this.queryData.pageNum = 1;
      this.orderLogQueryPage();
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.orderLogQueryPage();
    },
    resetPopupData() {
      this.$emit('closeDialog');
    },
    async orderLogQueryPage() {
      const res = await api.orderLogQueryPage(this.queryData);
      if (res.code === '200') {
        this.tableData = res.data.records;
        this.pageTotal = res.data.total;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
